define(["require", "exports", "jquery"], function (require, exports, $) {
    "use strict";
    exports.__esModule = true;
    function radioList($list, callback) {
        $list.find('.option').off('click').click(function (e) {
            var $opt = $(e.currentTarget);
            if (!$opt.hasClass('selected')) {
                $list.find('.option.selected').toggleClass('selected', false);
                $opt.toggleClass('selected', true);
                callback($opt);
            }
        });
    }
    exports.radioList = radioList;
    function radioButtons($buttons) {
        $buttons.off('click').on('click', function (e) {
            e.preventDefault();
            var $button = $(e.currentTarget);
            var $radio = $button.prev('input');
            var newVal = !$radio.prop('checked');
            $radio.prop('checked', newVal);
            $radio.trigger('change');
        });
    }
    exports.radioButtons = radioButtons;
    function radioCurrent(radioName, val) {
        if (!val) {
            var $selectedRadio = $("input[name=\"" + radioName + "\"]:checked");
            if (val === undefined) {
                return $selectedRadio.val();
            }
            if (val === null) {
                $selectedRadio.prop('checked', false);
                $selectedRadio.trigger('change');
                return;
            }
        }
        var $radio = $("input[name=\"" + radioName + "\"][value=\"" + val + "\"]");
        $radio.prop('checked', true);
        $radio.trigger('change');
    }
    exports.radioCurrent = radioCurrent;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/radioList.js
// module id = 59
// module chunks = 0